// Full-document render of the customer "Review Your Purchases" page: the
// breadcrumbs-block, the personalized heading, the shared multi-product
// write-review form island, and the iovation fraud scripts (injected
// post-hydration by IovationScripts).
import React from "react";
import { IovationScripts } from "tsi-common-react/src/components/IovationScripts/index";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Template as MultiProductWriteReviewForm } from "./MultiProductWriteReviewFormTemplate";

// Exported for the vitest pin: IovationScripts renders null on the server, so
// only a client render can prove the page still mounts it, and rendering the
// whole Template would drag in PageSkeleton's full GlobalChrome context.
export const ReviewOrderProductsScripts = (props: {
    iovationUrl: string;
}): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    return (
        <IovationScripts
            iovationUrl={props.iovationUrl}
            staticBase={chrome.static_base}
        />
    );
};

export const Template = (
    props: templates.ReviewOrderProductsDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title order-list">
                <section className="breadcrumbs-block">
                    {props.crumbs.map((crumb, i) => (
                        <React.Fragment key={i}>
                            {i > 0 && " / "}
                            {crumb.href ? (
                                <a href={crumb.href}>{crumb.label}</a>
                            ) : (
                                crumb.label
                            )}
                        </React.Fragment>
                    ))}
                </section>

                <h2>{props.heading}</h2>

                <MultiProductWriteReviewForm {...props.review_form} />
            </div>
            <ReviewOrderProductsScripts iovationUrl={props.iovation_url} />
        </PageSkeleton>
    );
};
